import type {
  ChallengeInitiateBody,
  ContactCreateBody,
  ContactDeleteBody,
  ContactUpdateBody,
  SmsChallengeConfirmationBody,
} from './generated/model/index.js';
import {
  createContact as createContactRequest,
  deleteContact as deleteContactRequest,
  confirmEmailVerification,
  confirmSms,
  getListContactsQueryKey,
  getListContactsQueryOptions,
  getGetCurrentVerificationChallengesQueryKey,
  getGetCurrentVerificationChallengesQueryOptions,
  initiate,
  status,
  updateContact as updateContactRequest,
} from './generated/contacts/contacts.js';

export {
  getListContactsQueryKey as getContactListQueryKey,
  getListContactsQueryOptions as getContactListQueryOptions,
  getGetCurrentVerificationChallengesQueryKey as getVerificationChallengesQueryKey,
  getGetCurrentVerificationChallengesQueryOptions as getVerificationChallengesQueryOptions,
};

type CommandOptions = { readonly headers: Record<string, string> };

export function createContact(userId: string, body: ContactCreateBody, options: CommandOptions) {
  return createContactRequest(userId, body, options);
}

export function updateContact(
  userId: string,
  contactId: string,
  body: ContactUpdateBody,
  options: CommandOptions,
) {
  return updateContactRequest(userId, contactId, body, options);
}

export function deleteContact(
  userId: string,
  contactId: string,
  body: ContactDeleteBody,
  options: CommandOptions,
) {
  return deleteContactRequest(userId, contactId, body, options);
}

export function initiateContactChallenge(
  userId: string,
  contactId: string,
  body: ChallengeInitiateBody,
  options: CommandOptions,
) {
  return initiate(userId, contactId, body, options);
}

export function getContactChallengeStatus(userId: string, contactId: string, challengeId: string) {
  return status(userId, contactId, challengeId);
}

export function confirmSmsContact(
  userId: string,
  contactId: string,
  challengeId: string,
  body: SmsChallengeConfirmationBody,
  options: CommandOptions,
) {
  return confirmSms(userId, contactId, challengeId, body, options);
}

export function confirmEmailContact(options: CommandOptions) {
  return confirmEmailVerification({}, options);
}
